export const summeritems = [
  {
    "id": "17",
    "name": "Lightweight Linen Shirt",
    "description": "Stay cool and stylish with our lightweight linen shirt.",
    "brand": "SummerBreeze",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Skyblue",
    "color2": "Beige",
    "image": "Lightweight Linen Shirt.jpg",
    "price": "2929"
  },
  {
    "id": "18",
    "name": "Flowy Maxi Dress",
    "description": "Make a statement with our flowy maxi dress.",
    "brand": "SunnyStyle",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Coral",
    "color2": "Yellow",
    "image": "Flowy Maxi Dress.avif",
    "price": "4379"
  },
  {
    "id": "19",
    "name": "Denim Shorts",
    "description": "Classic denim shorts for a casual summer look.",
    "brand": "BeachLife",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Lightblue",
    "color2": "White",
    "image": "Denim Shorts.jpg",
    "price": "2199"
  },
  {
    "id": "20",
    "name": "Sun Hat",
    "description": "Protect yourself from the sun with our stylish sun hat.",
    "brand": "SunSeeker",
    "size1": "One Size",
    "color1": "Natural",
    "color2": "Straw",
    "image": "Sun Hat.jpg",
    "price": "1449"
  },
  {
    "id": "21",
    "name": "Sunglasses",
    "description": "Shield your eyes from the sun with our trendy sunglasses.",
    "brand": "ShadeMaster",
    "size1": "One Size",
    "color1": "Black",
    "color2": "Tortoise",
    "image": "Sunglasses.jpg",
    "price": "1019"
  },
  {
    "id": "22",
    "name": "Beach Towel",
    "description": "Relax by the beach with our soft and absorbent beach towel.",
    "brand": "BeachEssentials",
    "size1": "One Size",
    "color1": "Striped",
    "color2": "Patterned",
    "image": "Beach Towel.jpg",
    "price": "1699"
  },
  {
    "id": "23",
    "name": "Cotton Tank Top",
    "description": "Stay cool and comfortable with our cotton tank top.",
    "brand": "CoolBreeze",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "White",
    "color2": "Gray",
    "image": "Cotton Tank Top.jpg",
    "price": "1449"
  },
  {
    "id": "24",
    "name": "Flip Flops",
    "description": "Slip into comfort with our stylish flip flops.",
    "brand": "BeachLife",
    "size1": "US 5-10",
    "color1": "Blue",
    "color2": "Pink",
    "image": "Flip Flops.jpg",
    "price": "919"
  },
  {
    "id": "25",
    "name": "Swimsuit",
    "description": "Dive into style with our flattering swimsuit.",
    "brand": "BeachGlam",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Red",
    "color2": "Black",
    "image": "Swimsuit.jpg",
    "price": "4879"
  },
  {
    "id": "26",
    "name": "Lightweight Shorts",
    "description": "Stay comfortable in the heat with our lightweight shorts.",
    "brand": "SummerEase",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Khaki",
    "color2": "Olive",
    "image": "Lightweight Shorts.jpg",
    "price": "3149"
  },
  {
    "id": "27",
    "name": "Cotton Sundress",
    "description": "Enjoy the sun in our breezy cotton sundress.",
    "brand": "SunnyStyle",
    "size1": "XS",
    "size2": "S",
    "size3": "M",
    "size4": "L",
    "color1": "Yellow",
    "color2": "Floral",
    "image": "Cotton Sundress.jpg",
    "price": "4049"
  },
  {
    "id": "28",
    "name": "Straw Hat",
    "description": "Complete your beach look with our chic straw hat.",
    "brand": "BeachChic",
    "size1": "One Size",
    "color1": "Natural",
    "color2": "Beige",
    "image": "Straw Hat.jpg",
    "price": "1699"
  },
  {
    "id": "29",
    "name": "Lightweight Tank Top",
    "description": "Stay cool and casual with our lightweight tank top.",
    "brand": "SummerBreeze",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Blue",
    "color2": "Green",
    "image": "Lightweight Tank Top.jpg",
    "price": "1019"
  },
  {
    "id": "30",
    "name": "Beach Bag",
    "description": "Carry your essentials in style with our spacious beach bag.",
    "brand": "BeachEssentials",
    "size1": "One Size",
    "color1": "Striped",
    "color2": "Patterned",
    "image": "Beach Bag.jpg",
    "price": "2199"
  }
];
